import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useReactMediaRecorder } from "react-media-recorder"
import fixWebmDuration from 'webm-duration-fix';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';
import { callNewRect, callNewRect2  } from '../../slices/students/globalSlice';
import Loader from '../../components/Loader';
import Message from '../../components/Message';


const StudenCamera = () => {


    const mimeType = 'video/webm\;codecs=vp9';

    const navigate = useNavigate();
    const dispatch = useDispatch(); 

    const { id } = useParams();

    const { studentInfo } = useSelector((state) => state.authStudent);

    const [showVideo, setshowVideo] = useState(false);
    const [showRecordButtons, setshowRecordButtons] = useState(true);
    const [showStopButtons, setshowStopButtons] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [timeLeft, setTimeLeft] = useState(300); //change it to 300 (5 min)

    useEffect(() => {
        if(!studentInfo) {
            navigate('/studentlogin')
        }
    }, [navigate, studentInfo])

    const startRec = () => { //start timer
        setIsRecording(true);
        setTimeLeft(300); //change it to 300 (5 min)
        dispatch(callNewRect()); // Dispatch the action
   };

   console.log('timeleftCam ', timeLeft);
 
    const stopRec = () => {
        setIsRecording(false);
        setTimeLeft(0); 
        dispatch(callNewRect2()); // Dispatch the action
   };
 
    useLayoutEffect(() => {
        let timer;
        if (isRecording && timeLeft > 0) {
        timer = setTimeout(() => {
            setTimeLeft(timeLeft - 300);
        }, 300000);
        } else if (timeLeft === 0) {
            stopRec();
            stopRecording();
        }
        return () => clearTimeout(timer);
    }, [isRecording, timeLeft]);

    const formatTimeLeft = () => {
        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };
 
    async function getString(mediaBlobUrl) {
        const mediaBlob = await fetch(mediaBlobUrl)
            .then(response => response.blob());
                const fixBlob = await fixWebmDuration(new Blob([mediaBlob], { type: mimeType }));                
                var fd = new FormData();
                fd.append('upl', fixBlob);
                fd.append('id', id);
                fetch('/api/upload',
                {
                    method: 'post',
                    body: fd
                });    
    }

    const VideoPreview = ({ stream }) => {
        const videoRef = useRef(null);
        useEffect(() => {
            if (videoRef.current && stream) {
                videoRef.current.srcObject = stream;
            }
        }, [stream]);
        if (!stream) {
            return null;
        }
        return <video ref={videoRef} autoPlay controls loop />;
    };

      const { status, startRecording, stopRecording, mediaBlobUrl, previewStream } = useReactMediaRecorder(
        { 
            video: true,
            screen: false, 
            onStart: () => {
                setshowStopButtons(true)
                setshowRecordButtons(false)
                startRec() //start timer
            },
            onStop: (blobUrl, blob) => {
                getString(blobUrl) 
                setshowVideo(true)
                setshowRecordButtons(false)
                setshowStopButtons(false)
                stopRec();
            }            
        });

  return (
    <div>
        <StudentNavbar />
        <div className="main-content" id="panel">
            <StudentHeader />
            <div className="container-fluid mt--6">
                <div className="row">
                {showRecordButtons ? ( 
                    <div>
                        <div className="offset-xl-1 col-xl-10">   
                            <h5 className="h3 card-title mb-0 mycard">
                            <h4 className="tittleColor4 recordTittle">
                                Click on Record Cam  and allow to the browser to acces your camera
                                <h6 className="tittleColor4 ">
                                (You can record up to 5 minutes of video)
                                </h6>
                            </h4>
                            <br /> 
                            </h5>
                        </div>
                        <div className="offset-xl-4 col-xl-4 " onClick={startRecording}>   
                            <div className="card rounded-pill mouseP">
                                <div className="card-body recordVid33">
                                    <div className="row">
                                    <div className="sidenav-header recordButt33 col-xl-4" >
                                        <img src="../../assets/img/rec3.png" className="navbar-brand-img recordButt33 recordButt34"  style={{ height: "100%"}}  />
                                    </div>
                                    <div className="col recordButton33 col-xl-8">
                                        <span  className="h2 font-weight-bold mb-0 tittleColor4 recordButton33 recordVid339">Record Cam</span>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>  
                ) : ( 
                    <p></p>
                )} 
                {showStopButtons ? ( 
                    <div>                        
                        <div className="col-lg-8 offset-lg-2 "> <br /><br /><br />
                            <div className="card mycard">
                                <VideoPreview className="card-img-top"  stream={previewStream} />   <br /> 
                                {/* <video className="card-img-top"  stream={previewStream} />    */}
                                {/* {isRecording && <p className='timeLeft2'>Time Left: {formatTimeLeft()}</p> } */}
                                {/* <p className='timeLeft2 '>Time Left: 04:18</p>  */}
                                <div className="offset-xl-3 col-xl-6 " onClick={stopRecording}>   
                                    <div className="card rounded-pill mouseP recArea2">
                                        <div className="card-body ">
                                            <div className="row ">
                                                <div className="sidenav-header  recordButt33 col-xl-4" >
                                                    <img src="../../assets/img/stop1.png" className="navbar-brand-img recordButt33 recImg2"  style={{ height: "90%"}}  />
                                                </div>
                                                <div className="col    col-xl-8 stopR ">
                                                    <span  className="h5 font-weight-bold mb-0  tittleColor4  stopRec31">Stop recording</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                ) : ( 
                    <p></p>
                )}
                {showVideo ? ( 
                    <div className="col-lg-8 offset-lg-2  "> <br /><br /><br />                        
                        <div className="card mycard">
                            <video className="card-img-top" src={mediaBlobUrl} controls autoPlay loop />
                            <div className="card-body "><br /><br />  
                                <LinkContainer to={`/studentasktype/${id}`} className='btn btn-danger '>
                                    <Button variant="primary  bg-gradient-danger" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-info' > &nbsp; Record Again &nbsp; </Button>
                                </LinkContainer>&nbsp; &nbsp;
                                <LinkContainer to={`/studentnewanswer`} className='btn btn-primary '>
                                    <Button variant="primary  bg-gradient-primary" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-primary'>&nbsp; Save Video &nbsp; </Button>
                                </LinkContainer>
                            </div>
                        </div>
                    </div>
                ) : ( 
                    <p></p> )
                }  
                </div>
            </div>
        </div>
    </div>
  )
}

export default StudenCamera
